







import store from '@/store';

export default
  name: 'SearchButton'

  props:
    # ラベル
    label:
      type: String
      default: ''

  # click: クリックイベント
  methods: {
    click: (e) ->
      @$emit('click')
  }
